<template>
  <div class="schoolinfo-edit">
    <div class="edit-logo">
      <el-upload class="avatar-uploader" :action="LogAction" :show-file-list="false" accept=".jpg,.png,.jpeg"
        ref="upload" :data="uploadData" :before-upload="beforeUpload" :headers="headers" :on-success="onSuccess"
        :on-error="onError" name="schoolLog" :disabled="disabled">
        <el-image :src="schoolLogo" fit="cover">
          <div slot="error" class="image-slot" style="
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              background: #f5f7fa;
              color: #c0c4cc;
            ">
            <div>无图片</div>
          </div>
        </el-image>
      </el-upload>
    </div>
    <el-form :model="ruleForm" label-width="130px" :rules="rules" ref="ruleForm" class="edit-form">
      <el-form-item label="学校名称:" prop="schoolName">
        <el-input :disabled="disabled" v-model="ruleForm.schoolName" placeholder="请输入学校名称"> </el-input>
      </el-form-item>
      <el-form-item label="学校邀请码:">
        <el-col :span="22">
          <el-form-item prop="schoolName">
            <el-input v-model="ruleForm.remark" placeholder="" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1">&nbsp;</el-col>
        <el-col :span="1">
          <!-- 复制邀请码 -->
          <el-form-item>
            <div class="copy-button" @click="copyRemark">
              <i class="iconfont icon-copy"></i>
            </div>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label="学校地址:" prop="address">
        <el-input :disabled="disabled" v-model="ruleForm.address" placeholder="请输入学校地址"> </el-input>
      </el-form-item>
      <el-form-item label="当前学年:" prop="address">
        <!-- <el-date-picker
          style="width: 320px"
          v-model="ruleForm.schoolYearVal"
          type="year"
          placeholder="选择学年"
          :disabled="disabled"
        >
        </el-date-picker> -->
        <year-range-picker v-model="ruleForm.schoolYearVal" />
      </el-form-item>
      <el-form-item label="当前学期:" prop="address">
        <el-select v-model="ruleForm.semesterVal" placeholder="请选择学期" style="width: 320px" :disabled="disabled">
          <el-option v-for="item in semesterOptions" :key="item.dictValue" :label="item.dictLabel"
            :value="item.dictValue">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="教师评定开放时间:" prop="teTimeRange">
        <el-date-picker
          v-model="ruleForm.teTimeRange"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%"
          :disabled="disabled">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="学校简介" prop="introduction">
        <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6 }" v-model="ruleForm.introduction"
          :maxlength="maxlength" show-word-limit :disabled="disabled">
        </el-input>
      </el-form-item>
    </el-form>
    <!-- 按钮 -->
    <div class="edit-submit">
      <!-- <div class="line"></div> -->
      <div class="submit" @click="submitForm('ruleForm')" v-hasPermi="'sc:school:edit'">
        提交
      </div>
    </div>
    <!-- 新增一个input框(用来复制邀请码)，然后设置 opacity:0; 实现不可见， position:absolute; 脱离文档流解决占空间的问题 -->
    <el-input id="remark" v-model="ruleForm.remark" placeholder="" style="opacity: 0; position: absolute"></el-input>
  </div>
</template>

<script>
import { baseURL } from "@/api/request";
import axios from "axios";

export default {
  name: "",
  data() {
    return {
      schoolLogo: "",
      logoFile: {},
      ruleForm: {
        schoolName: "", // 学校名称
        remark: "", // 邀请码
        address: "", // 地址
        introduction: "", // 简介
        schoolYearVal: "", // 学年
        semesterVal: "", // 学期
        teTimeRange: [], // 学生评定时间范围
      },
      rules: {
        schoolName: [{ required: true, message: "请输入学校名称", trigger: "blur" }],
        // address: [
        //   { required: true, message: "请输入学校地址", trigger: "change" },
        // ],
      },
      maxlength: 400, // textarea字数
      submit: {
        schoolName: "",
        address: "",
        introduction: "",
      },
      // 上传路径
      action: "",
      // logo上传路径
      LogAction: "",
      // 上传的请求头
      headers: {},
      // 上传携带参数
      uploadData: {},
      formDate: "", // formData上传参数
      semesterOptions: [],
      schoolInfo: null,
      disabled: false
    };
  },
  created() {
    this.getDictType();
    this.getSchoolDetails();
    this.action = `${baseURL}${this.$url.putSchool}`;
    this.LogAction = `${baseURL}${this.$url.putSchoolLog}`;
    this.disabled = !window.localStorage.getItem("menuPermissions").split(',').includes('sc:school:edit'); // 判断是否有编辑权限
  },
  methods: {
    // 查询学校信息
    getSchoolDetails() {
      this.get(this.$url.getSchoolDetails).then((res) => {
        // console.log("查询学校信息==>", res);
        this.schoolInfo = res.data;
        // this.schoolInfo = res.data;
        let schoolInfo = res.data;
        this.ruleForm.semesterVal = schoolInfo.semester;
        this.ruleForm.schoolYearVal = schoolInfo.schoolYear;
        this.schoolLogo = schoolInfo.logo;
        this.ruleForm.remark = schoolInfo.remark;
        this.ruleForm.schoolName = schoolInfo.schoolName;
        this.ruleForm.address = schoolInfo.address;
        this.ruleForm.introduction = schoolInfo.introduction.replace(/[<p>|</p>]/g, "");
        // 设置学生评定时间范围
        if (schoolInfo.teStartTime && schoolInfo.teEndTime) {
          this.ruleForm.teTimeRange = [schoolInfo.teStartTime, schoolInfo.teEndTime];
        }
      });
    },
    // 获取学期类型选择列表数据
    getDictType() {
      this.get(`${this.$url.getDictType}/semester_type`).then((res) => {
        // console.log("学期类型==>", res);
        this.semesterOptions = res.data;
      });
    },
    // 文件上传前 若返回 false 或者返回 Promise 且被 reject，则停止上传。
    beforeUpload(file) {
      let limit = file.size / 1024 / 1024 < 2;
      let file_type = file.name.split(".")[1];
      if (!/^(jpg|png|jpeg)$/g.test(file_type)) {
        this.$message.warning("请选择jpg,png,jpeg类型文件");
        return false;
      } else if (!limit) {
        this.$message.warning("上传图片大小不能超过 2MB!");
        return false;
      } else {
        // 请求头 token
        this.headers.bbfAdminTeacherToken = window.localStorage.getItem(
          "bbfAdminTeacherToken"
        );
        // 上传携带参数
        this.uploadData.id = this.schoolInfo.id;
        this.uploadData.updateBy = this.user.id;
      }
    },
    // 上传成功
    onSuccess(res, file, fileList) {
      console.log(res);
      if (res.code == 200 && res.data > 0) {
        this.getSchoolDetails();
        this.$message.success("修改成功");
        // this.$store
        //   .dispatch("school/getSchool", { id: this.schoolInfo.id })
        //   .then((res) => {
        //     // console.log(this.school);
        //     this.schoolLogo = this.schoolInfo.logo;
        //     this.$message.success("修改成功");
        //   })
        //   .catch((err) => {
        //     this.$message.error("获取最新信息失败");
        //   });
      } else if (res.code == 401 || res.code == 403) {
        // token失效
        this.$message.error("获取用户信息失败，请重新登录");
        this.$store.dispatch("user/resetToken");
        this.$router.replace({
          path: "login",
          query: { redirect: this.$router.currentRoute.fullPath },
        });
      } else {
        this.$message.error("修改失败");
      }
    },
    // 上传失败
    onError(err, file, fileList) {
      // console.log(err);
      return this.$message.error("上传失败，请稍后再试");
    },
    // 修改学校信息
    submitForm(formName) {
      // console.log(this.school);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // new FormData()创建创建FormData对象
          this.formDate = new FormData();
          let config = {
            headers: {
              bbfAdminTeacherToken: window.localStorage.getItem("bbfAdminTeacherToken"),
              "Content-Type": "multipart/form-data",
            },
          };
          let {
            address,
            introduction,
            schoolName,
            semesterVal,
            schoolYearVal,
            teTimeRange,
          } = this.ruleForm;
          console.log("this.ruleForm:", this.ruleForm);
          // 如果学年未修改则用接口返回的值，修改后则提取日期内的年并转为字符串
          let schoolYear =
            typeof schoolYearVal == "string"
              ? schoolYearVal
              : "" + schoolYearVal.getFullYear();
          this.formDate.append("id", this.user.schoolId);
          this.formDate.append("updateBy", this.user.id);
          this.formDate.append("schoolName", schoolName);
          this.formDate.append("address", address);
          this.formDate.append("introduction", introduction);
          this.formDate.append("schoolYear", schoolYearVal);
          this.formDate.append("semester", semesterVal);
          // console.log("修改学校信息参数==>", this.formDate, config);
          let data = {
            id: this.user.schoolId,
            schoolName,
            address,
            introduction,
            schoolYear,
            semester: semesterVal,
            teStartTime: teTimeRange && teTimeRange.length > 0 ? teTimeRange[0] : null,
            teEndTime: teTimeRange && teTimeRange.length > 1 ? teTimeRange[1] : null,
          };
          // console.log(data);
          this.put(this.action, data).then((res) => {
            // console.log(res);
            let data = res;
            if (data.code == 200 && data.data == 1) {
              this.$message.success("修改成功");
              this.getSchoolDetails();
              // this.$store
              //   .dispatch("school/getSchool", { id: this.schoolInfo.id })
              //   .then((res) => {
              //     // console.log(this.school);
              //     this.$message.success("修改成功");
              //   })
              //   .catch((err) => {
              //     this.$message.error("获取最新信息失败");
              //   });
            } else if (data.code == 401 || data.code == 403) {
              // token失效
              this.$message.error("获取用户信息失败，请重新登录");
              this.$store.dispatch("user/resetToken");
              this.$router.replace({
                path: "login",
                query: { redirect: this.$router.currentRoute.fullPath },
              });
            } else {
              this.$message.error("修改失败");
            }
          });

          // axios
          //   .put(this.action, this.formDate, config)
          //   .then((res) => {
          //     // console.log(res);
          //     let data = res.data;
          //     if (data.code == 200 && data.data == 1) {
          //       this.$store
          //         .dispatch("school/getSchool", { id:  this.schoolInfo.id })
          //         .then((res) => {
          //           // console.log(this.school);
          //           this.$message.success("修改成功");
          //         })
          //         .catch((err) => {
          //           this.$message.error("获取最新信息失败");
          //         });
          //     } else if (data.code == 401 || data.code == 403) {
          //       // token失效
          //       this.$message.error("获取用户信息失败，请重新登录");
          //       this.$store.dispatch("user/resetToken");
          //       this.$router.replace({
          //         path: "login",
          //         query: { redirect: this.$router.currentRoute.fullPath },
          //       });
          //     } else {
          //       this.$message.error("修改失败");
          //     }
          //   })
          //   .catch((err) => {
          //     console.log(err);
          //     // this.$message.error("修改失败，请稍后再试");
          //   });
        } else {
          return false;
        }
      });
    },
    // 复制邀请码
    copyRemark() {
      let copyVal = document.getElementById("remark");
      copyVal.select();
      try {
        document.execCommand("copy");
        this.$message.success("已复制到粘贴板");
      } catch {
        this.$message.error("当前浏览器不支持复制到粘贴板");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./schoolinfo-edit.scss";
</style>
